import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Show {
    constructor() {
        this.initTaxatie();
    }

    initTaxatie() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            },
        });
    }
}
